<template>
  <div
    class="
      relative
      flex
      items-top
      justify-center
      min-h-screen
      bg-gray-100
      sm:items-center
      sm:pt-0
    "
  >
    <div class="max-w-6xl mx-auto sm:px-6 lg:px-8">
      <div class="flex justify-center pt-8 sm:justify-start">
        <img
          src="/img/RA-logo-02.png"
          class="h-20 w-auto text-gray-700 sm:h-20"
        />
        <img
          src="/img/logo-thnic.svg"
          class="h-20 w-auto text-gray-700 sm:h-20"
        />
        <div class="ml-5">
          <div
            class="text-sm sm:text-2xl text-blue-900"
          >
            Workshop สร้าง Sale Page เปิดร้านออนไลน์ ด้วยเว็บไซต์หน้าเดียว ฉบับจับมือทำ
          </div>
          <div class="text-sm sm:text-sm mt-1">
            จัดโดย Robinhood Academy ร่วมกับ มูลนิธิศูนย์สารสนเทศเครือข่ายไทย
          </div>
        </div>
      </div>

      <div class="mt-6 bg-white overflow-hidden shadow sm:rounded-lg">
        <div class="bg-blue-900 px-6 py-8">
          <div class="text-white text-center font-semibold">
            <div class="text-yellow-500 text-2xl">ลงทะเบียนไม่สำเร็จ</div>
            <div class="text-white text-xl mt-4">{{ registration.remark }}</div>
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 border-t border-gray-200">
            <div class="p-6">
              <div class="flex items-center">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  class="w-8 h-8 text-gray-500"
                >
                  <path
                    d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
                  ></path>
                </svg>
                <div class="ml-4 text-lg leading-7 font-semibold">
                  <span class="text-blue-900">ข้อกำหนดและเงื่อนไข</span>
                </div>
              </div>

              <div class="ml-12">
                <div class="mt-2 text-gray-600 text-sm">
                  <ul class="mt-2 ml-3 list-outside list-disc">
                    <li>สามารถจดทะเบียนโดเมนได้เพียง 1 ชื่อเท่านั้น</li>
                    <li>
                      ได้รับ ชื่อ domain .in.th และ .ไทย ฟรีเป็นระยะเวลาหนึ่งปี
                    </li>
                    <li>
                      ได้รับบริการ Zavanna Sale Page ฟรีเป็นระยะเวลาหนึ่งปี
                    </li>
                    <li v-if="type == 'C'">
                      สำหรับโดเมน .co.th ชื่อโดเมนจำเป็นต้องสอดคล้อง,
                      เป็นส่วนใดส่วนหนึ่ง หรือย่อมาจากชื่อองค์กรหรือร้านค้าเท่านั้น
                    </li>
                    <li>
                      มูลนิธิฯขอสงวนสิทธิ์การปฏิเสธการจดทะเบียนชื่อโดเมนที่ไม่เป็นไปตามเงื่อนไขข้างต้น
                    </li>
                    <li>
                      หากต้องการต่ออายุโดเมนสามารถติดต่อ support@dotarai.com เพื่อรับข้อมูลการต่ออายุ
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="p-6 border-t border-gray-200 md:border-t-0 md:border-l">
              <div class="flex items-center">
                <svg
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  class="w-8 h-8 text-gray-500"
                >
                  <path
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <div class="ml-4 text-lg leading-7 font-semibold">
                  <span class="text-blue-900"
                    >สิ่งที่จะได้รับหลังจากลงทะเบียน</span
                  >
                </div>
              </div>

              <div class="ml-12">
                <div class="mt-2 text-gray-600 text-sm">
                  หลังจากที่มูลนิธิฯ
                  ตรวจสอบข้อมูลยืนยันตัวตนเรียบร้อยแล้ว
                  และส่งจดทะเบียนชื่อโดเมนสำเร็จ ท่านจะได้รับ
                  <ul class="mt-2 ml-3 list-outside list-disc">
                    <li>ชื่อ Domain ตามที่ท่านได้เลือกไว้</li>
                    <li>Zavanna Sale Page </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
      </div>

      <div class="my-4 grid grid-cols-1 md:grid-cols-2">
        <div class="text-sm text-center md:text-left text-gray-500">
          <a href="http://robin23.dotarai.co.th" class="ml-1 underline">
            กลับไปหน้าแรก
          </a>
        </div>

        <div
          class="
            mt-3
            md:mt-0
            text-sm text-center
            md:text-right
            text-gray-500
            sm:ml-0
          "
        >
          Workshop สร้าง Sale Page เปิดร้านออนไลน์ ด้วยเว็บไซต์หน้าเดียว ฉบับจับมือทำ
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["registration"],
};
</script>
